/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import upperFirst from 'lodash/upperFirst';

import { UIcon } from 'shared-ui/uicon';

import { getActiveAiQuery } from '../../actions/search';
import { useAppSelector } from '../../redux/redux-helpers';

import styles from './AiSearchPrompt.module.scss';

/**
 * Shows the query an AI search was started with, above the search results. Renders
 * nothing once a search for other criteria is sent.
 */
export function AiSearchPrompt() {
    const aiQuery = useAppSelector(getActiveAiQuery);

    if (!aiQuery.trim()) {
        return null;
    }

    return (
        <div className={styles.prompt}>
            <div className={styles.iconSlot}>
                <UIcon
                    name="sparkles"
                    size={16}
                    className="color-text-02"
                    strokeWidth={1.75}
                    aria-label="AI search"
                />
            </div>
            <div className={styles.contentSlot}>
                <span className="font-weight-semibold">AI Search: </span>“
                {upperFirst(aiQuery.trim())}”
            </div>
        </div>
    );
}
